// Documentation: https://github.com/pimterry/loglevel

// Note the levels:
// logMethods = [
//   "trace",
//   "debug",
//   "info",
//   "warn",
//   "error"
// ];

import log from "loglevel";

const qlogBase = log.noConflict();

if (globalThis.Qwoted?.BUSINESS_ENVIRONMENT === "production") {
  qlogBase.setLevel("warn");
} else {
  qlogBase.setLevel("debug");
}

// Create a wrapper that allows qlog() to work as qlog.debug()
const qlog = (...args) => qlogBase.debug(...args);

// Copy all the log level methods to the wrapper
Object.setPrototypeOf(qlog, qlogBase);
Object.keys(qlogBase).forEach((key) => {
  if (key !== "name") {
    qlog[key] = qlogBase[key];
  }
});

// Allow access from browser javascript console ...
if (typeof window !== "undefined") {
  window.qlog = qlog;
}
// Turn on logging in production with:
// window.qlog.setLevel('trace');

export default qlog;
